<!--  -->
<template>
<div class=''>
  <Nav :navList="navList"></Nav>
  <transition name="el-zoom-in-center">
    <div style="width:100%;height:100%" v-show="show">
      <el-image v-if="backImg == undefined||backImg==''" style="display:flex;justify-content: center;align-items: center;" class="brandBg" fit="cover" :src="'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'">
        <div slot="error" style="font-size:25px;color:gray">
                {{brandBgMessage}}
        </div>
      </el-image>
      <el-image v-else :src="backImg" class="brandBg"></el-image>
      <div class="brand-content">
        <div class="pagination-wrapper"> 
              <div class="nav-btn left-btn" @click="toLeft()">
              <svg width="50" height="50" viewBox="0 0 200 200">
                <polygon class="direction" stroke-linejoin="round" points="60,100 110,56 110,140"/>
              </svg>
              <span>BACK</span>
              </div>
              <div class="nav-btn right-btn" @click="toRight()">
              <span>NEXT</span>
              <svg width="50" height="50" viewBox="0 0 200 200">
                <polygon class="direction" stroke-linejoin="round" points="110,100 60,56 60,140"/>
              </svg>
              </div>
        </div>
        <div class="brand-grid">
          <div v-if="brandData.list==undefined||brandData.list.length==0" class="brandView"  key="0">
            <el-image :style="`width:510px;height:350px;border-radius:10px;border:1px solid gray;display: flex;align-items: center;justify-content: center;`" :src="'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'">
              <div slot="error" style="font-size:25px;color:gray">
                {{message}}
              </div>
            </el-image>
            <span style="margin-top:30px;font-size: 18px;color:mediumvioletred">{{ message }}</span>
          </div>
          
          <div v-show="brandData.list && brandData.list.length>0" class="brandView" @click="toTheHtml(item.id)" v-for="item in brandData.list" :key="item.id">
            <el-image v-if="item && item.backImg" :src="item.backImg" style="width:510px;height:350px;border-radius:10px;">
              <div slot="error" style="font-size:25px;color:gray">图片加载失败</div>
            </el-image>
            <span style="margin-top:30px;font-size: 18px;">{{item.title!=undefined&&item.title!=""?item.title:"标题加载失败......"}}</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Nav from "@/components/Nav"
import {queryList,queryBackImg} from '@/api/web/brandInformation'
import {loadingTime} from '@/utils/const.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {Nav},
data() {
//这里存放数据
return {
 navList:["品牌资讯"],
 backImg:"",
 brandData:{},
 show:false,
 current:1,
 message:"请稍等,品牌资讯信息正在加载中......",
 brandBgMessage:"请稍等,正在加载中......"
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  toLeft(){
    var _this = this
    if(this.current==1){
      return;
    }
    _this.brandData = {}
    _this.message="请稍等,品牌资讯信息正在加载中......"
    setTimeout(()=>{
       if(!_this.brandData.list||_this.brandData.list.length==0){
          _this.message="品牌资讯信息加载失败,请重新刷新页面"
       }
    },loadingTime)
    queryList({"current":--this.current}).then((res)=>{
      _this.brandData = res && res.data ? res.data : {}
    })   
  },
  toRight(){
    var _this = this
    if(this.current==this.brandData.totalPage){
      return;
    }
    _this.brandData = {}
    _this.message="请稍等,品牌资讯信息正在加载中......"
    setTimeout(()=>{
       if(!_this.brandData.list||_this.brandData.list.length==0){
          _this.message="品牌资讯信息加载失败,请重新刷新页面"
       }
    },loadingTime)
    queryList({"current":++this.current}).then((res)=>{
      _this.brandData = res && res.data ? res.data : {}
    }) 
  },
  toTheHtml(id){
    this.$router.push({name:'brandInformationShow',params:{id:id}})
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
 this.show=true
 var _this = this
 setTimeout(()=>{
       if(!_this.brandData.list||_this.brandData.list.length==0){
          _this.message="品牌资讯信息加载失败,请重新刷新页面"
       }
       if(!_this.backImg){
        _this.brandBgMessage="加载失败,请重新刷新页面"
       }
    },loadingTime)
 queryBackImg().then((res)=>{
  const data = res && res.data ? res.data : null
  if (data) {
    _this.backImg = data
  } else {
    _this.backImg = ''
  }
 },()=>{
  _this.brandBgMessage="加载失败,请重新刷新页面"
 })
 queryList({"current":this.current}).then((res)=>{
  _this.brandData = res && res.data ? res.data : {}
 },()=>{
  _this.message="品牌资讯信息加载失败,请重新刷新页面"
 })
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
/** scoped 表示 样式自在当前组件有效*/
//@import url(); 引入公共css类
.brandBg{
  height:418px;
  width:100%;
  
  @media screen and (max-width: 768px) {
    height: 150px;
  }
}

.brand-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  
  @media screen and (max-width: 768px) {
    padding: 0;
    box-sizing: border-box;
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  width: 1700px;
  margin-top: 20px;
  
  @media screen and (max-width: 1919px) and (min-width: 1367px) {
    width: 90%;
  }
  
  @media screen and (max-width: 1366px) and (min-width: 1025px) {
    width: 90%;
  }
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    width: 90%;
  }
  
  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 0 15px;
    margin-top: 10px;
    box-sizing: border-box;
  }
}

.nav-btn {
  display: flex;
  justify-content: space-between;
  width: 130px;
  height: 50px;
  cursor: pointer;
  align-items: center;
  
  span {
    line-height: 53px;
    height: 50px;
    font-size: 30px;
    
    @media screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 35px;
      height: 35px;
    }
  }
  
  svg {
    @media screen and (max-width: 768px) {
      width: 24px;
      height: 24px;
    }
  }
  
  @media screen and (max-width: 768px) {
    width: 60px;
    height: 35px;
  }
}

.brand-grid {
  display: flex;
  justify-content: flex-start;
  width: 1700px;
  margin-top: 30px;
  flex-shrink: 0;
  flex-wrap: wrap;
  
  @media screen and (max-width: 1919px) and (min-width: 1367px) {
    width: 90%;
    justify-content: space-around;
  }
  
  @media screen and (max-width: 1366px) and (min-width: 1025px) {
    width: 90%;
    justify-content: space-around;
  }
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    width: 90%;
    justify-content: space-around;
  }
  
  @media screen and (max-width: 768px) {
    width: 100%;
    margin-top: 15px;
    padding: 0;
    box-sizing: border-box;
    flex-direction: column;
    align-items: center;
  }
}

.brandView:not(:nth-child(3n+3)){
  margin-right:85px; 
  
  @media screen and (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 20px;
  }
}

.brandView{
  display:flex;
  flex-direction:column;
  align-items:center;
  width:510px;
  height:400px;
  cursor:pointer;
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    width: 350px;
    height: 300px;
    
    .el-image {
      width: 350px !important;
      height: 240px !important;
    }
  }
  
  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    height: auto;
    margin-bottom: 20px;
    padding: 0 15px;
    box-sizing: border-box;
    
    .el-image {
      width: 100% !important;
      height: 200px !important;
      border-radius: 8px !important;
    }
    
    span {
      font-size: 14px !important;
      margin-top: 10px !important;
      width: 100%;
      text-align: center;
    }
  }
}

.direction {
  fill: rgb(0, 0, 0);
  stroke: rgb(0, 0, 0);
  stroke-width: 25;
}
</style>
